import { Routes, Route } from "react-router";

import { AppShell } from "./components/app-shell";
import { RequireAuth } from "./components/require-auth";
import { Login } from "./routes/login";
import { ForgotPassword } from "./routes/forgot-password";
import { ResetPassword } from "./routes/reset-password";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="*"
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
